import { Skeleton } from '@heroui/react';

import { DeploymentActionsMenu } from '~/scenes/Runtime/scenes/Deployments/components/DeploymentActionsMenu';

export type DeploymentActionsCellProps = {
  onDeleteDeploy: () => void;
  onGoToPipeline: () => void;
  onRedeploy: () => void;
  onPromote: () => void;
  onRollback: () => void;
  onViewExecutions: () => void;
  onOpenVersionDiff: () => void;
  isDisabled?: boolean;
  showPromote?: boolean;
  environment?: string;
  pipelineVersionMajor?: number;
  pipelineVersionMinor?: number;
};

export const DeploymentActionsCell = ({
  onDeleteDeploy,
  onGoToPipeline,
  onRedeploy,
  onPromote,
  onRollback,
  onViewExecutions,
  onOpenVersionDiff,
  isDisabled = false,
  showPromote = false,
  environment,
  pipelineVersionMajor,
  pipelineVersionMinor
}: DeploymentActionsCellProps) => (
  <div className='deployment-actions flex'>
    <DeploymentActionsMenu
      onPromote={onPromote}
      onRedeploy={onRedeploy}
      onRollback={onRollback}
      onDeleteDeploy={onDeleteDeploy}
      onGoToPipeline={onGoToPipeline}
      onViewExecutions={onViewExecutions}
      onOpenVersionDiff={onOpenVersionDiff}
      isDisabled={isDisabled}
      showPromote={showPromote}
      environment={environment}
      testIdPrefix='run-deployed-pipelines-list-view-deployment'
      pipelineVersionMajor={pipelineVersionMajor}
      pipelineVersionMinor={pipelineVersionMinor}
    />
  </div>
);

export const DeploymentActionsCellSkeleton = () => (
  <div className='deployment-actions flex'>
    <Skeleton className='h-8 w-8 rounded' />
  </div>
);
